import { defineComponent as s, ref as r, watch as a } from "vue";
import { useBaseApplicationTranslation as m } from "../../../shared/libraries/local-translations/index.js";
const p = s({
  name: "Links",
  props: {
    links: {
      type: Array,
      required: !0
    }
  },
  setup(o) {
    const t = r([]), e = r([]);
    a(
      () => o.links,
      (n) => {
        t.value = n[0], e.value = n[1];
      },
      { immediate: !0 }
    );
    const { t: i } = m();
    return {
      leftColumnLinks: t,
      rightColumnLinks: e,
      t: i
    };
  }
});
export {
  p as default
};
//# sourceMappingURL=index15.js.map
